export const categories: string[] = [
  'Body Building',
  'Boxing',
  'Crossfit',
  'Fitness',
  'Meditation',
  'Yoga',
];

export const tags: string[] = [
  'Crossfit',
  'Fitness',
  'Gym',
  'Meditation',
  'Running',
  'Workout',
  'Yoga',
  'Boxing',
];
